<template>
    <div id="contenedor-main-listado-municipios">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoMunicipios="listadoMunicipios"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoMunicipios="listadoMunicipios"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoMunicipios',
  props: {
    listadoMunicipios: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
